import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/logo.svg";
import kuwait from "../../assets/kwait.svg";
import usa from "../../assets/usa.svg";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { changeLang } from "../../store/actions/LangActions";
import "./style.css";

const Navbar = () => {
	const [isHome, setIsHome] = useState(false);
	const location = useLocation();
	const dispatch = useDispatch();
	const lang = useSelector((state) => state.lang.lang);
	const { t, i18n } = useTranslation();

	const changeLanguage = (lng) => {
		i18n.changeLanguage(lng);
		dispatch(changeLang(lng));
	};

	useEffect(() => {
		let pathname = location.pathname.slice(1);
		if (!pathname) {
			setIsHome(true);
		} else {
			setIsHome(false);
		}
	}, [location]);

	const closeMenu = () => {
		const navbarCollapse = document.getElementById("navbarNavAltMarkup");
		if (navbarCollapse.classList.contains("show")) {
			const bsCollapse = new window.bootstrap.Collapse(navbarCollapse, {
				toggle: false,
			});
			navbarCollapse.classList.remove("show");
			bsCollapse.hide();
		}
	};
	return (
		<div>
			<nav className="navbar navbar-expand-lg">
				<Link to="/" className="mobile-logo m-0 p-0">
					<img src={logo} alt="logo" width={55} />
				</Link>
				<div>
					<button
						className="navbar-toggler"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#navbarNavAltMarkup"
						aria-controls="navbarNavAltMarkup"
						aria-expanded="false"
						aria-label="Toggle navigation">
						<span className="navbar-toggler-icon"></span>
					</button>
					<div
						className="collapse navbar-collapse"
						style={{ width: "fit-content" }}
						id="navbarNavAltMarkup">
						<button
							className="navbar-toggler navbar-toggler2"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#navbarNavAltMarkup"
							style={{
								width: "40px",
								height: "40px",
								border: "0",
							}}
							aria-controls="navbarNavAltMarkup"
							aria-expanded="false">
							<span style={{ fontSize: "32px", lineHeight: "0" }}>x</span>
						</button>
						<div className="navbar-nav">
							<NavLink
								to="/"
								className={({ isActive }) =>
									isActive ? "active nav-link" : "nav-link"
								}
								onClick={closeMenu}
								aria-current="page">
								{t("home")}
							</NavLink>
							<NavLink
								to="/projects"
								className={({ isActive }) =>
									isActive ? "active nav-link" : "nav-link"
								}
								onClick={closeMenu}
								aria-current="page">
								{t("Our Projects")}
							</NavLink>

							<NavLink
								to="/media-center"
								className={({ isActive }) =>
									isActive ? "active nav-link" : "nav-link"
								}
								onClick={closeMenu}
								aria-current="page">
								{t("Media Center")}
							</NavLink>
							<Link to="/" className="navbar-brand disktop-logo logo m-0 p-0">
								<img src={logo} alt="logo" />
							</Link>

							<NavLink
								to="/about-us"
								className={({ isActive }) =>
									isActive ? "active nav-link" : "nav-link"
								}
								onClick={closeMenu}
								aria-current="page">
								{t("about-us")}
							</NavLink>
							<NavLink
								to="/contact-us"
								state={""}
								className={({ isActive }) =>
									isActive ? "active nav-link" : "nav-link"
								}
								onClick={closeMenu}
								aria-current="page">
								{t("contact us")}
							</NavLink>
							<button
								style={{
									fontFamily: lang === "en" ? "Almarai-Bold" : "GeneralSans",
								}}
								onClick={() => {
									changeLanguage(lang === "en" ? "ar" : "en");
									closeMenu();
								}}
								className="nav-link d-flex gap-8 align-items-center">
								<img
									src={lang === "en" ? kuwait : usa}
									alt="language"
									className="language"
									width={40}
									height={24}
								/>{" "}
								{lang === "en" ? "اللغه العربيه" : "English"}
							</button>
						</div>
					</div>
				</div>
			</nav>
		</div>
	);
};
export default Navbar;
